"use strict";

var _classCallCheck = require("C:\\Users\\the_i\\Desktop\\bachelor\\bachelor-docker\\infra\\frontend-user\\bachelor-user-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\the_i\\Desktop\\bachelor\\bachelor-docker\\infra\\frontend-user\\bachelor-user-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MINIMUM_RETRY_DELAY = 1000;
var MAXIMUM_RETRY_DELAY = 4000;
var MAXIMUM_ATTEMPTS_COUNT = 3;
var RETRY_WHEN_THROTTLED = true;

var Configuration = /*#__PURE__*/function () {
  function Configuration(token, baseUrl, options) {
    _classCallCheck(this, Configuration);

    var constructorOptions = options.MCS || options || {};
    this.region = constructorOptions.region || options.region;
    this.baseUrl = (typeof this.region === 'undefined' ? 'https://mcs.us1.twilio.com' : "https://mcs.".concat(this.region, ".twilio.com")) + baseUrl;
    this.token = token;
    this.retryWhenThrottledOverride = constructorOptions.retryWhenThrottledOverride;
    this.backoffConfigOverride = constructorOptions.backoffConfigOverride;
  }

  _createClass(Configuration, [{
    key: "updateToken",
    value: function updateToken(token) {
      this.token = token;
    }
  }], [{
    key: "backoffConfigDefault",
    get: function get() {
      return {
        min: MINIMUM_RETRY_DELAY,
        max: MAXIMUM_RETRY_DELAY,
        maxAttemptsCount: MAXIMUM_ATTEMPTS_COUNT
      };
    }
  }, {
    key: "retryWhenThrottledDefault",
    get: function get() {
      return RETRY_WHEN_THROTTLED;
    }
  }]);

  return Configuration;
}();

exports.Configuration = Configuration;